import { useState, useContext } from 'react';

import { AppContext } from 'commons-ui';
import { IkindRewardFilterData, ContentPropsT } from '../kindReward.model';

const useFilter = (props: ContentPropsT) => {
	const { handleFilterSubmit, onClose } = props;

	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);

	const handleFormSubmit = async (submittedData: IkindRewardFilterData): Promise<void> => {
		try {
			const { tournamentID, userId } = submittedData;
			setShowLoader(true);
			handleFilterSubmit({
				tournamentID,
				userId
			});
			setShowLoader(false);
		} catch (error) {
			showAlert('Error in fetching kind reward data', { type: 'error' });
		} finally {
			onClose();
		}
	};

	const handleFormCancel = (): void => {
		onClose();
	};

	return {
		showLoader,
		setShowLoader,
		handleFormSubmit,
		handleFormCancel
	};
};

export default useFilter;
